<template>
	<section id="revit-banner" class="checklist mt-30">
		<div class="checkbox checkbox--small checkbox--disabled mb-20">
			<input type="checkbox" class="checkbox__input" checked>
			<span class="checkbox__label light-font-color" style="--start: var(--disabled);--main-font: var(--disabled);">Проставляйте галочки после выполнения каждого практического задания</span>
		</div>

		<h2 class="checklist__title">Подготовительный этап (до прихода сотрудника)</h2>
		<div class="checklist__list">
			<h3 class="checklist__subtitle">Подготовка рабочего места</h3>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q1" v-model="edusonChecklist">
				<span class="checkbox__label">Компьютер</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q2" v-model="edusonChecklist">
				<span class="checkbox__label">Служебный номер</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q3" v-model="edusonChecklist">
				<span class="checkbox__label">Канцелярия</span>
			</label>
		</div>
		<div class="checklist__list">
			<h3 class="checklist__subtitle">Проверка доступа к системам и ресурсам</h3>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q4" v-model="edusonChecklist">
				<span class="checkbox__label">Настройка корпоративной почты, учетной записи и доступов</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q5" v-model="edusonChecklist">
				<span class="checkbox__label">Подготовка приветственного пакета (кружка, блокнот)</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q6" v-model="edusonChecklist">
				<span class="checkbox__label">Проведение тренингов</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q7" v-model="edusonChecklist">
				<span class="checkbox__label">ТБ</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q8" v-model="edusonChecklist">
				<span class="checkbox__label">СБ</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q9" v-model="edusonChecklist">
				<span class="checkbox__label">ИБ</span>
			</label>
		</div>
		<h2 class="checklist__title">День 1</h2>
		<div class="checklist__list">
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q10" v-model="edusonChecklist">
				<span class="checkbox__label">Встреча сотрудника на входе</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q11" v-model="edusonChecklist">
				<span class="checkbox__label">Знакомство с коллегами и руководством</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q12" v-model="edusonChecklist">
				<span class="checkbox__label">Проведение экскурсии по офису (рабочие зоны, кухня, комнаты отдыха, туалет)</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q13" v-model="edusonChecklist">
				<span class="checkbox__label">Ознакомление с регламентом работы (рабочие часы, обеденные перерывы, правила использования систем и оборудования)</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q14" v-model="edusonChecklist">
				<span class="checkbox__label">Презентация компании: миссия, ценности, цели, структура</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q15" v-model="edusonChecklist">
				<span class="checkbox__label">Описание задач на испытательный срок и ожидания от сотрудника</span>
			</label>
		</div>
		<h2 class="checklist__title">День 2</h2>
		<div class="checklist__list">
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q16" v-model="edusonChecklist">
				<span class="checkbox__label">Организация встречи нового сотрудника с непосредственным руководителем</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q17" v-model="edusonChecklist">
				<span class="checkbox__label">Знакомство с рабочими системами и программами (ECM, Outlook, Connect, Jira)</span>
			</label>
		</div>
		<h2 class="checklist__title">День 3</h2>
		<div class="checklist__list">
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q18" v-model="edusonChecklist">
				<span class="checkbox__label">Ознакомление нового сотрудника с текущими проектами и задачами</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q19" v-model="edusonChecklist">
				<span class="checkbox__label">Ознакомление нового сотрудника с инструментами проекта</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q20" v-model="edusonChecklist">
				<span class="checkbox__label">Обучение основным рабочим процессам</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q21" v-model="edusonChecklist">
				<span class="checkbox__label">
					Ознакомление нового сотрудника с системой отчетности, делопроизводства и внутреннего документооборота,
					а также обсуждение стандартов и процедуры компании
				</span>
			</label>
		</div>
		<h2 class="checklist__title">День 4-5</h2>
		<div class="checklist__list">
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q22" v-model="edusonChecklist">
				<span class="checkbox__label">Наблюдение и поддержка нового сотрудника</span>
			</label>
		</div>
		<h2 class="checklist__title">День 6</h2>
		<div class="checklist__list">
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q23" v-model="edusonChecklist">
				<span class="checkbox__label">Организация встречи с руководителем (при необходимости)</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q24" v-model="edusonChecklist">
				<span class="checkbox__label">Наблюдение и поддержка нового сотрудника</span>
			</label>
		</div>
		<h2 class="checklist__title">Оценка по окончанию программы адаптации (1 месяц)</h2>
		<div class="checklist__list">
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q25" v-model="edusonChecklist">
				<span class="checkbox__label">Проведение итоговой встречи: оценка результатов, обсуждение дальнейшего плана работы</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q26" v-model="edusonChecklist">
				<span class="checkbox__label">Корректировка задач и обязанностей (если необходимо)</span>
			</label>
			<label class="checkbox">
				<input @change="checkboxHandler" type="checkbox" class="checkbox__input" value="q27" v-model="edusonChecklist">
				<span class="checkbox__label">Подведение итогов адаптационного периода: удовлетворенность сотрудника, трудности, предложения по улучшению</span>
			</label>
		</div>

		<div class="longread longread--no-pads mt-20" style="font-size:14px;">
			<div class="checklist__subtitle">Рекомендации для куратора:</div>
			<ol class="order-list">
				<li>Будьте на&nbsp;связи: Представьтесь новому сотруднику и&nbsp;объясните, что вы&nbsp;его куратор. Напомните, что он&nbsp;может обращаться к&nbsp;вам по&nbsp;любым вопросам.</li>
				<li>Помогите в&nbsp;первые дни: Проводите нового сотрудника по&nbsp;офису, познакомьте с&nbsp;коллегами и&nbsp;объясните внутренние процессы.</li>
				<li>Четко разъясняйте задачи: Поделитесь базовой информацией о&nbsp;работе и&nbsp;ожиданиях отдела, помогите разобраться с&nbsp;ключевыми системами и&nbsp;инструментами.</li>
				<li>Регулярно проверяйте прогресс: Встречайтесь с&nbsp;новым сотрудником для обсуждения, чтобы убедиться, что ему комфортно.</li>
				<li>Делитесь неформальной информацией: Расскажите об&nbsp;атмосфере в&nbsp;коллективе, традициях и&nbsp;негласных правилах.</li>
				<li>Создайте дружественную атмосферу: Поддерживайте нового сотрудника, будьте терпеливы и&nbsp;открыты, чтобы он&nbsp;быстрее адаптировался.</li>
				<li>Постепенность: Не&nbsp;перегружайте сотрудника информацией, давайте время на&nbsp;усвоение новых знаний.</li>
			</ol>
		</div>
	</section>
</template>

<script>
export default {
	name: 'CourseChecklist',

	props: {
		url: '',
	},

	data() {
		return {
			edusonChecklist: [],
		}
	},

	mounted() {
		this.edusonChecklist = JSON.parse(localStorage.edusonChecklist);
	},

	methods: {
		checkboxHandler() {
			localStorage.edusonChecklist = JSON.stringify(this.edusonChecklist);
		}
	}
}
</script>

<style>
.checklist {
	display: grid;
	grid-template-columns: 1fr;
	gap: 20px;
	padding: 24px;
	border: 1px solid var(--border-color);
	border-radius: 6px;
	background-color: var(--white);
}

.checklist__title {
	font-weight: 700;
	font-size: 20px;
}

.checklist__subtitle {
	margin-bottom: 10px;
	font-weight: 700;
}

.checklist__list {
	display: grid;
	grid-template-columns: 1fr;
	gap: 5px;
	padding-left: 28px;
}

.checklist__list .checkbox__label {
	font-size: 16px;
}
</style>
